import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { login as apiLogin, getMe, setToken, getToken } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!getToken()) { setReady(true); return; }
    getMe()
      .then((me) => setAdmin(me))
      .catch(() => setToken(null))
      .finally(() => setReady(true));
  }, []);

  useEffect(() => {
    const onExpire = () => setAdmin(null);
    window.addEventListener("nefa-auth-expired", onExpire);
    return () => window.removeEventListener("nefa-auth-expired", onExpire);
  }, []);

  const signIn = useCallback(async (email, password) => {
    const res = await apiLogin(email, password);
    setToken(res.token);
    setAdmin({ email: res.email, role: res.role });
    return res;
  }, []);

  const signOut = useCallback(() => {
    setToken(null);
    setAdmin(null);
  }, []);

  return (
    <AuthContext.Provider
      value={{
        admin,
        user: admin,
        role: admin?.role || null,
        isAdmin: admin?.role === "admin",
        isViewer: admin?.role === "viewer",
        isAuthed: !!admin,
        ready,
        signIn,
        signOut,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
